import * as CONST from "./actionTypes";

const intialState = {
  isLogin: false,
  loading: false,
  user: [],
  edituser: [],
  blockUnblockUser: [],
  acceptReject: [],
  deleteUser: [],
  sendEmail: {},
  sendText: {},
  documentFile: [],
  getDocumentFile: [],
  getNote: {},
  singleNote: {},
  draftEmails: {},
  SmsHistory: {},
  draftEmailById: {},
  error: null,
};

const UserReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    case CONST.CUSTOMERS_LIST:
      return {
        ...state,
        isLogin: true,
        loading: true,
        error: null,
      };
    case CONST.CUSTOMERS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        user: payload,
        error: null,
      };
    case CONST.CUSTOMERS_LIST_FAIL:
      return {
        ...state,
        loading: true,
        error: payload,
      };

    /* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.EDIT_CUSTOMER:
      return {
        ...state,
        isLogin: true,
        loading: true,
        error: null,
      };
    case CONST.EDIT_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        edituser: payload,
        error: null,
      };
    case CONST.EDIT_CUSTOMER_FAIL:
      return {
        ...state,
        loading: true,

        error: payload,
      };
    /* >>>>>>>>>>>>>> UPDATE CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.UPDATE_USER:
      return {
        ...state,
        isLogin: true,
        loading: true,

        error: null,
      };
    case CONST.UPDATE_USER_SUCCESS:
      return {
        ...state,

        loading: true,
        updateuser: { ...payload },
        error: null,
      };
    case CONST.UPDATE_USER_FAIL:
      return {
        ...state,
        loading: false,

        error: payload,
      };
    /* >>>>>>>>>>>>>> ADD CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.ADD_USER:
      return {
        ...state,
        isLogin: true,
        loading: true,

        error: null,
      };
    case CONST.ADD_USER_SUCCESS:
      return {
        ...state,

        loading: true,
        adduser: { ...payload },
        error: null,
      };
    case CONST.ADD_USER_FAIL:
      return {
        ...state,
        loading: false,

        error: payload,
      };
    /* >>>>>>>>>>>>>> BLOCK_UNBLOCK CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.BLOCK_UNBLOCK_USER:
      return {
        ...state,
        isLogin: true,
        loading: true,

        error: null,
      };
    case CONST.BLOCK_UNBLOCK_USER_SUCCESS:
      return {
        ...state,

        loading: true,
        blockUnblockUser: payload,
        error: null,
      };
    case CONST.BLOCK_UNBLOCK_USER_FAIL:
      return {
        ...state,
        loading: false,

        error: payload,
      };

    /* >>>>>>>>>>>>>> DELETE CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.DELETE_USER:
      return {
        ...state,
        isLogin: true,
        loading: true,

        error: null,
      };
    case CONST.DELETE_USER_SUCCESS:
      return {
        ...state,

        loading: true,
        deleteUser: payload,
        error: null,
      };
    case CONST.DELETE_USER_FAIL:
      return {
        ...state,
        loading: false,

        error: payload,
      };

    /* >>>>>>>>>>>>>> SEND EMAIL >>>>>>>>>>>>>>>*/

    case CONST.SEND_EMAIL:
      return {
        ...state,
        error: null,
      };
    case CONST.SEND_EMAIL_SUCCESS:
      return {
        ...state,
        sendEmail: { ...payload },
        error: null,
      };
    case CONST.SEND_EMAIL_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> SEND TEXT >>>>>>>>>>>>>>>*/

    case CONST.SEND_TEXT:
      return {
        ...state,
        error: null,
      };
    case CONST.SEND_TEXT_SUCCESS:
      return {
        ...state,
        sendText: { ...payload },
        error: null,
      };
    case CONST.SEND_TEXT_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> POST DOCUMENT FILE >>>>>>>>>>>>>>>*/

    case CONST.POST_DOCUMENT_FILE:
      return {
        ...state,
        error: null,
      };
    case CONST.POST_DOCUMENT_FILE_SUCCESS:
      return {
        ...state,
        documentFile: { ...payload },
        error: null,
      };
    case CONST.POST_DOCUMENT_FILE_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> DELETE USER DOCUMENT >>>>>>>>>>>>>>>*/

    case CONST.DELETE_USER_DOCUMENT:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_USER_DOCUMENT_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_USER_DOCUMENT_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> update document file >>>>>>>>>>>>>>>*/

    case CONST.UPDATE_DOCUMENT_FILE:
      return {
        ...state,
        error: null,
      };
    case CONST.UPDATE_DOCUMENT_FILE_SUCCESS:
      return {
        ...state,
        documentFile: { ...payload },
        error: null,
      };
    case CONST.UPDATE_DOCUMENT_FILE_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> GET document file >>>>>>>>>>>>>>>*/

    case CONST.GET_DOCUMENT_FILE:
      return {
        ...state,
        error: null,
      };
    case CONST.GET_DOCUMENT_FILE_SUCCESS:
      return {
        ...state,
        getDocumentFile: { ...payload },
        error: null,
      };
    case CONST.GET_DOCUMENT_FILE_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> accept reject document >>>>>>>>>>>>>>>*/

    case CONST.ACCEPT_REJECT_DOCUMENT:
      return {
        ...state,
        error: null,
      };
    case CONST.ACCEPT_REJECT_DOCUMENT_SUCCESS:
      return {
        ...state,
        acceptReject: { ...payload },
        error: null,
      };
    case CONST.ACCEPT_REJECT_DOCUMENT_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> SEND DOCUMENT LIST >>>>>>>>>>>>>>>*/

    case CONST.SEND_DOCUMENTS_LIST:
      return {
        ...state,
        error: null,
      };
    case CONST.SEND_DOCUMENTS_LIST_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.SEND_DOCUMENTS_LIST_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> RESET USER PASS >>>>>>>>>>>>>>>*/

    case CONST.RESET_USER_PASS:
      return {
        ...state,
        error: null,
      };
    case CONST.RESET_USER_PASS_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.RESET_USER_PASS_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> ADD NOTE >>>>>>>>>>>>>>>*/

    case CONST.ADD_NOTE:
      return {
        ...state,
        error: null,
      };
    case CONST.ADD_NOTE_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.ADD_NOTE_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> GET NOTE >>>>>>>>>>>>>>>*/

    case CONST.GET_NOTE_BY_ID:
      return {
        ...state,
        error: null,
        getNote: "",
      };
    case CONST.GET_NOTE_BY_ID_SUCCESS:
      return {
        ...state,
        getNote: payload,
        error: null,
      };
    case CONST.GET_NOTE_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> UPDATE NOTE >>>>>>>>>>>>>>>*/

    case CONST.UPDATE_NOTE:
      return {
        ...state,
        error: null,
      };
    case CONST.UPDATE_NOTE_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.UPDATE_NOTE_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> single NOTE >>>>>>>>>>>>>>>*/

    case CONST.GET_SINGLE_NOTE:
      return {
        ...state,
        error: null,
        singleNote: {},
      };
    case CONST.GET_SINGLE_NOTE_SUCCESS:
      return {
        ...state,
        error: null,
        singleNote: payload,
      };
    case CONST.GET_SINGLE_NOTE_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> delete NOTE >>>>>>>>>>>>>>>*/

    case CONST.DELETE_NOTE:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_NOTE_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_NOTE_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> sms history >>>>>>>>>>>>>>>*/

    case CONST.SMS_HISTORY:
      return {
        ...state,
        error: null,
        SmsHistory: {},
      };
    case CONST.SMS_HISTORY_SUCCESS:
      return {
        ...state,
        error: null,
        SmsHistory: payload,
      };
    case CONST.SMS_HISTORY_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> add email draft >>>>>>>>>>>>>>>*/

    case CONST.ADD_EMAIL_DRAFT:
      return {
        ...state,
        error: null,
      };
    case CONST.ADD_EMAIL_DRAFT_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.ADD_EMAIL_DRAFT_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> draft email list >>>>>>>>>>>>>>>*/

    case CONST.DRAFT_EMAIL_LIST:
      return {
        ...state,
        error: null,
        draftEmails: {},
      };
    case CONST.DRAFT_EMAIL_LIST_SUCCESS:
      return {
        ...state,
        error: null,
        draftEmails: payload,
      };
    case CONST.DRAFT_EMAIL_LIST_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> draft email by id >>>>>>>>>>>>>>>*/

    case CONST.DRAFT_EMAIL_BY_ID:
      return {
        ...state,
        error: null,
        draftEmailById: {},
      };
    case CONST.DRAFT_EMAIL_BY_ID_SUCCESS:
      return {
        ...state,
        error: null,
        draftEmailById: payload,
      };
    case CONST.DRAFT_EMAIL_BY_ID_FAIL:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;

      break;
  }
};

export default UserReducer;
